/* (ignored) */


/*****************
 ** WEBPACK FOOTER
 ** vertx (ignored)
 ** module id = 520
 ** module chunks = 1
 **/